import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes } from '@angular/router';
import { SettingsComponent } from './settings/settings.component';
import { ObjectFieldsComponent } from './object-fields/object-fields.component';
import { ObjectFieldTemplatesComponent } from './object-field-templates/object-field-templates.component';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    component: SettingsComponent,
    data: {
      title: 'Projekt'
    },
    children: [
      {
        path: 'object-fields',
        component: ObjectFieldsComponent,
      },
      {
        path: 'object-field-templates',
        component: ObjectFieldTemplatesComponent,
      }
    ]
  },
];


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SettingsRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/settings/settings-routing.module.ts